import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementTWLocale from 'element-ui/lib/locale/lang/zh-TW'
/* eslint-disable-next-line */
import locale from 'element-ui/lib/locale'
/* eslint-disable-next-line */
import Cookies from 'js-cookie'
//import en from './en'    //原来的国际化
//import zh from './zh-CN' //原来的国际化
import en from "./en-new"  //新国际化
import zh from "./zh-CN-new"//新国际化
import tw from "./tw-CH"//新国际化
import LangStorage from '../cookie'

Vue.use(VueI18n)

const messages = {
  en: {
    ...en,
    ...elementEnLocale
  },
  zh: {
    ...zh,
    ...elementZhLocale
  },
  tw:{
    ...tw,
    ...elementTWLocale
  }
}

let sysLan = LangStorage.getLang((navigator.language || navigator.browserLanguage).toLowerCase().slice(0, 2))
// console.log(sysLan)

const i18n = new VueI18n({
  locale: sysLan || 'zh', // set locale
  messages // set locale messages
})

locale.i18n(
  (key, value) => {
    i18n.t(key, value)
  }
)

export default i18n



// WEBPACK FOOTER //
// ./src/assets/js/lang/index.js